export default {
  createSuccess: "Struktur erfolgreich erstellt!",
  updated: "Struktur aktualisiert!",
  deviceNameEmpty: "Gerätename darf nicht leer sein",
  deviceRenamed: "Gerät umbenannt",
  adminRenameConfirmTitle: "Anzeigename ändern?",
  adminRenameConfirmMessage:
    "Der Anzeigename „{{name}}“ hilft Hosts, ihre Tablets zu erkennen. Eine Änderung ohne Zustimmung des Hosts kann Verwirrung stiften. Sie können dennoch fortfahren, falls nötig.",
  credentialsRegenerated: "Zugangsdaten neu generiert",
  createModal: {
    title: "Neue Struktur hinzufügen",
    houseNameLabel: "Strukturname *",
    houseNamePlaceholder: "z. B. Villa Sunset",
    addressRequired: "Geben Sie die Adresse der Struktur ein.",
    commissionPercentLabel: "Host-Anteil pro Buchung (%)",
    nameRequired: "Geben Sie einen Strukturnamen ein.",
    commissionPercentRange: "Geben Sie einen gültigen Prozentsatz ein.",
    salesAgent: "Vertriebsagent (Vertrag)",
    salesAgentSearchPlaceholder: "E-Mail eingeben zum Suchen…",
    salesAgentNoResults: "Keine Vertriebsagenten entsprechen Ihrer Suche.",
    salesAgentListEmpty: "Keine Vertriebsagenten verfügbar.",
    wizardStep2Lead:
      "Wählen Sie einen Vertriebsagenten aus der Liste oder überspringen Sie, um ohne Agent fortzufahren.",
    salesAgentCutPercentLabel: "Vertriebsagent-Provision (%)",
    salesAgentCutRequired:
      "Geben Sie die Vertriebsagent-Provision ein, wenn ein Agent ausgewählt ist.",
    wizardStep3Lead:
      "Geben Sie die vollständige Adresse für diese Struktur ein.",
    wizardNext: "Weiter",
    wizardSkip: "Überspringen",
    create: "Struktur erstellen",
  },
  adminCreate: {
    back: "Zurück zu Strukturen",
    backToHost: "Zurück zum Host",
  },
  list: {
    openHouse: "Öffnen",
    hostIdMissing: "Host-ID nicht gefunden. Bitte melden Sie sich als Host an.",
    titleAdminNoHosts: "Strukturen",
    subtitleAdminNoHosts:
      "Erstellen Sie zuerst einen Host, dann können Sie Strukturen für ihn hinzufügen.",
    emptyHosts:
      "Noch keine Hosts registriert. Fügen Sie Hosts im Bereich Hosts hinzu.",
    titleByHost: "Strukturen nach Host",
    titleMy: "Meine Strukturen",
    subtitleByHost:
      "Wählen Sie einen Host, dann dessen Strukturen anzeigen oder hinzufügen",
    subtitleMy: "Strukturen Ihres Kontos anzeigen und deren Tablets verwalten",
    hostLabel: "Host",
    selectHostAria: "Host auswählen",
    addHouse: "Struktur hinzufügen",
    emptyTitle: "Noch keine Strukturen",
    emptyDescAdmin: "Fügen Sie eine Struktur für diesen Host hinzu.",
    emptyDescHost: "Staff erstellt Strukturen für Ihr Konto.",
    addFirstHouse: "Erste Struktur hinzufügen",
    loading: "Strukturen werden geladen…",
    active: "Aktiv",
    inactive: "Inaktiv",
    commissionRate: "{{percent}} % Host-Anteil",
    hostOptionLabel: "{{name}} (Host)",
  },
  detail: {
    createdOn: "Erstellt am {{date}}",
    overview: {
      devices: "Tablets",
      devicesHint: "Dieser Struktur zugewiesen",
      devicesOnline_one: "{{count}} online",
      devicesOnline_other: "{{count}} online",
      guestsNow: "Gäste jetzt",
      guestsNowHint: "Belegte Tablets von {{count}}",
      upcoming: "Anstehende Ankünfte",
      upcomingHint: "Künftige Aufenthalte auf den Tablets",
      hostShare: "Host-Anteil",
      hostShareHint: "Auf jede Buchung über die Tablets dieser Unterkunft",
    },
    settings: {
      visibilityTitle: "Sichtbarkeit",
    },
    notFoundMessage:
      "Diese Struktur wurde möglicherweise entfernt oder Sie haben keinen Zugriff darauf.",
    loading: "Struktur wird geladen…",
    back: "Zurück zu Strukturen",
    backToHouses: "Zurück zu Strukturen",
    goToPartner: "Zum Partner",
    partnerLabel: "Partner",
    tabs: {
      settings: "Einstellungen",
      ariaLabel: "Einrichtungsbereiche der Struktur",
      devices: "Geräte",
      devicesHintAdmin:
        "Tablets dieser Struktur zuweisen, Zahlungsleser verknüpfen und Gerätezugangsdaten verwalten.",
      presences: "Anwesenheiten",
    },
    presences: {
      staysTitle: "Aufenthalte",
      segmentCurrent: "Aktuell ({{count}})",
      segmentUpcoming: "Anstehend ({{count}})",
      segmentAria: "Aufenthaltsansicht",
      currentHint:
        "Gäste, die derzeit Tablets in dieser Struktur zugewiesen sind, wie vom Host gemeldet.",
      upcomingHint:
        "Gäste mit geplanter Anreise auf Tablets in dieser Struktur, einschließlich aus PDF importierter Aufenthalte.",
      historyHeading: "Historische Belegung",
      historyHint:
        "Belegung = belegte Gerätezeit geteilt durch Gesamtkapazität im gewählten Zeitraum.",
      loadingHistory: "Anwesenheiten im Zeitraum werden geladen…",
      errorConnectionMessage:
        "Prüfen Sie Ihre Verbindung oder Berechtigungen und versuchen Sie es erneut.",
      errorHistoryTitle:
        "Anwesenheiten im Zeitraum konnten nicht geladen werden",
      emptyCurrentMessage:
        "Kein Tablet in dieser Struktur hat derzeit einen aktiven Gast.",
      emptyUpcomingMessage:
        "Für diese Struktur sind keine bevorstehenden Gästeaufenthalte geplant.",
      emptyHistoryMessage:
        "Keine Anwesenheiten überschneiden sich mit dem gewählten Zeitraum.",
      colDevice: "Gerät",
      colNationality: "Nationalität",
      colMarketing: "Marketing",
      colGuests: "Gäste",
      colContacts: "Kontakte",
      copyContactHint: "Zum Kopieren klicken",
      guestsWithCount: "{{name}} (×{{count}})",
      childrenBadgeHint: "Kinder sind Teil dieses Aufenthalts",
      colArrival: "Anreise",
      colDeparture: "Abreise",
      colNotes: "Notizen",
      notesAria: "Gästenotizen anzeigen",
      colActions: "Aktionen",
      editAction: "Anwesenheit bearbeiten",
      deleteAction: "Anwesenheit entfernen",
      editModalTitle: "Anwesenheit bearbeiten – {{deviceName}}",
      consentMarketing: "Direktmarketing",
      consentProfiling: "Profiling",
      consentThirdParty: "Marketing durch Dritte",
      consentGrantedHint: "Der Gast hat zugestimmt zu:",
      consentDeniedHint: "Der Gast hat keine Marketing-Einwilligung erteilt.",
      valueUnknown: "—",
      genericGuestName: "Gast",
      dateFrom: "Von",
      dateTo: "Bis",
      applyRange: "Anwenden",
      resetRange: "Letzte 3 Monate",
      metricOccupancy: "Belegung",
      metricOccupancyHint:
        "Durchschnittliche Tablet-Belegung im gewählten Zeitraum",
      metricDevices: "Geräte",
      metricPresences: "Anwesenheiten",
      chartHeading: "Tägliche Belegung",
      chartAria: "Diagramm der täglichen Belegung für den gewählten Zeitraum",
      periodTableHeading: "Anwesenheiten im Zeitraum",
      periodTableHint:
        "Aufenthalte, die sich mit dem gewählten Zeitraum überschneiden.",
      currentIndicatorHint: "Diese Anwesenheit ist derzeit aktiv.",
      emptyPeriodMessage:
        "Keine Anwesenheiten überschneiden sich mit dem gewählten Zeitraum.",
    },
    presenceImport: {
      title: "Anwesenheiten aus PDF importieren",
      adminOnly: "Nur Staff",
      barHint:
        "Gästeaufenthalte aus einem PDF extrahieren (auch Scans), dann Pflichtfelder prüfen.",
      open: "PDF importieren",
      hint: "Beliebiges Belegungs-PDF hochladen — Gästelisten, PMS-Exporte oder Scans. Fehlende Pflichtfelder ausfüllen, dann speichern.",
      fileLabel: "Nur PDF",
      dropHint: "Klicken, um ein PDF auszuwählen",
      extract: "Aufenthalte extrahieren",
      save: "Anwesenheiten speichern",
      cancel: "Verwerfen",
      chooseAnother: "Anderes PDF wählen",
      addRow: "Aufenthalt hinzufügen",
      previewCount: "{{count}} Aufenthalt/Aufenthalte zur Prüfung",
      colDevice: "Gerät",
      colGuest: "Gastname",
      colNationality: "Nationalität",
      colArrival: "Anreise",
      colDeparture: "Abreise",
      devicePlaceholder: "Gerät auswählen",
      unmatchedHint: "Aus dem PDF: {{room}}",
      removeRow: "Aufenthalt entfernen",
      pickFile: "Wählen Sie zuerst eine PDF-Datei.",
      emptyPreview:
        "Keine Aufenthalte zum Speichern. Erneut extrahieren oder verwerfen.",
      toastExtracted:
        "{{count}} Aufenthalt/Aufenthalte extrahiert. Vor dem Speichern prüfen.",
      toastSaved: "{{count}} Anwesenheit(en) gespeichert.",
      undo: "Rückgängig",
      discardConfirmTitle: "Arbeit verwerfen?",
      discardConfirmMessage:
        "Wenn Sie ohne Speichern fortfahren, gehen die Bearbeitungen der extrahierten Aufenthalte verloren.",
      discardConfirmAction: "Verwerfen und fortfahren",
      discardConfirmCancel: "Weiter bearbeiten",
      extractingHint: "PDF wird analysiert…",
      fileSelectedHint:
        "PDF ausgewählt — klicken, um eine andere Datei zu wählen",
      unassignedBanner:
        "{{count}} Aufenthalt(e) ohne Tablet. Vor dem Speichern allen ein Tablet zuweisen.",
      unassignedDeviceError: "Tablet zuweisen",
      unassignedDeviceTitle: "Kein Tablet zugewiesen",
      assignedDeviceTitle: "Tablet zugewiesen",
      scheduleHint: "Standardzeiten: Check-in ~15:00 · Check-out ~10:00",
      invalidDateRange: "Abreise vor Anreise",
    },
    visibilityLabel: "Aktive Struktur",
    visibilityHint:
      "Inaktive Strukturen sind in Host-Workflows ausgeblendet, bis sie reaktiviert werden.",
    visibilityToggleAria: "Diese Struktur aktivieren oder deaktivieren",
    devicesTitle: "Geräte ({{count}})",
    noDevices: "Keine Geräte in dieser Struktur",
    noDevicesHint:
      "Staff kann neue Geräte im Tab Geräte erstellen und sie hier zuweisen.",
    deviceNamePlaceholder: "Gerätename",
    renameDeviceTitle: "Gerät umbenennen",
    kioskCode: "Gerätecode",
    serialLabel: "S/N",
    currentGuest: "Aktueller Gast",
    guestDeparts: "reist ab am {{date}}",
    statusRevoked: "Widerrufen",
    statusCreated: "Erstellt",
    statusActive: "Aktiv",
    regenerateConfirm:
      "Passwort für „{{name}}“ neu generieren? Bestehende Tablet-Sitzungen werden ungültig und das aktuelle Passwort funktioniert nicht mehr.",
    credentialModalTitle: "Zugangsdaten neu generiert",
    credentialModalDesc:
      "Das Passwort wurde neu generiert. Speichern Sie diese Zugangsdaten jetzt: Das Passwort wird nur einmal angezeigt.",
    managePresences: "Gäste verwalten",
    addPresences: "Gäste erfassen",
    noGuestPresence: "Noch keine Gäste erfasst",
    queuedGuests: "{{count}} in der Warteschlange",
    queuedGuests_one: "1 in der Warteschlange",
    noCurrentGuestWithQueue:
      "Kein aktueller Gast · {{count}} in der Warteschlange",
    noCurrentGuestWithQueue_one: "Kein aktueller Gast · 1 in der Warteschlange",
    refreshCredentials: "Zugangsdaten aktualisieren",
    refreshingCredentials: "Wird aktualisiert…",
    hostDevicesCaption:
      "Anmeldecodes und Gerätedetails verwaltet Staff. Setzen Sie hier einen verständlichen Tablet-Namen, ziehen Sie zum Sortieren und erfassen Sie Gäste.",
    dragToReorder: "Zum Sortieren ziehen",
    modalHouseName: "Strukturname",
  },
  adminDetail: {
    houseName: "Strukturname",
    placeholderHouseName: "z. B. Beach Villa",
    locationTitle: "Standort",
    commissionSettings: "Host-Anteil-Einstellungen",
    commissionPct: "Host-Anteil pro Buchung (%)",
    commissionPlaceholder: "z. B. 5",
    assignDevice: "Gerät zuweisen",
    assignDeviceCta: "Gerät zuweisen",
    colDevice: "Anzeigename",
    colSerial: "S/N",
    colGoogleAccount: "Google-Konto",
    colFreekioskUnlock: "FK-Entsperrung",
    colReader: "Lesegerät",
    colLastTelemetry: "Letzte Telemetrie",
    colLastInteraction: "Letzte Interaktion",
    colAppVersion: "App-Version",
    colInUse: "Im Einsatz",
    colActions: "Aktionen",
    renameDeviceTitle: "Anzeigename bearbeiten",
    displayNamePlaceholder: "Anzeigename",
    displayNameEmpty: "Anzeigename darf nicht leer sein",
    editGoogleAccountTitle: "Google-Konto bearbeiten",
    editNotesTitle: "Notizen",
    notesPlaceholder: "Notiz hinzufügen…",
    moreActionsTitle: "Weitere Aktionen",
    readerPair: "Verknüpfen",
    readerUnpairTitle: "Lesegerät trennen",
    readerUnpairConfirm:
      "Lesegerät von diesem Tablet trennen? Die SumUp-Kopplung bleibt erhalten; Zahlungen bleiben deaktiviert, bis Sie erneut verknüpfen.",
    readerUnpaired: "Lesegerät getrennt",
    unassignDeviceTitle: "Gerätezuweisung aufheben",
    menuRegenerateCredentials: "Zugangsdaten neu generieren",
    menuRevokeDevice: "Anmeldedaten widerrufen",
    menuReactivateDevice: "Anmeldedaten reaktivieren",
    menuManagePresences: "Gäste verwalten",
    menuNotes: "Notizen",
    menuOtherInfo: "Weitere Infos",
    toastAssignSuccess: "Gerät erfolgreich zugewiesen!",
    toastUpdateSuccess: "Struktur erfolgreich aktualisiert!",
    toastReaderUpdated: "Lesegerät aktualisiert",
    toastDeviceRevoked: "Gerät widerrufen",
    toastDeviceReactivated: "Gerät reaktiviert",
    toastDeviceShelved: "Gerät geparkt",
    toastDeviceUnshelved: "Gerät wieder im Einsatz",
    toastDeviceUnassigned: "Gerätezuweisung aufgehoben",
    toastDeviceRenamed: "Gerät umbenannt",
    toastGoogleAccountUpdated: "Google-Konto aktualisiert",
    toastNotesUpdated: "Notizen aktualisiert",
    unassignConfirm: "Zuweisung von „{{name}}“ zu dieser Struktur aufheben?",
    assignModalTitle: "Gerät der Struktur zuweisen",
    assignModalIntro: "Wählen Sie ein Gerät für {{houseName}}:",
    searchDevicesLabel: "Geräte suchen",
    filterDevicesPlaceholder: "Name, Code oder Seriennr.…",
    searchDevicesPlaceholder: "Suche nach Anzeigename, Code oder Seriennummer…",
    assignModalNoResultsSearch: "Keine Geräte entsprechen „{{query}}“.",
    assignModalNoResults: "Keine verfügbaren Geräte zum Zuweisen.",
    assign: "Zuweisen",
    deviceListMeta: "{{code}} — S/N: {{serial}}",
    otherInfoTitle: "Weitere Geräteinformationen",
    fieldDisplayName: "Anzeigename",
    fieldKioskCode: "Gerätecode",
    fieldSerialNumber: "Seriennummer",
    fieldGoogleAccount: "Google-Konto",
    fieldSoftwareId: "Software-ID",
    fieldReaderId: "Lesegerät-ID",
    fieldBrand: "Marke",
    fieldDisplayInches: "Display-Zoll",
    fieldResolution: "Auflösung",
    fieldAndroidVersion: "Android-Version",
    fieldAppVersion: "App-Version",
    valueAppVersionUnknown: "Unbekannt",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    fieldLastTelemetryReport: "Letzte empfangene Telemetrie",
    sectionTelemetryData: "Telemetriedaten",
    sectionTelemetryDeviceStatus: "Gerätestatus (FreeKiosk)",
    sectionTelemetryGpsLocation: "Standort (Geräte-GPS)",
    valueTelemetryNever: "Nie",
    valueTelemetryEmpty: "Noch keine Daten",
    valueUnbound: "Nicht gebunden",
    valueNotPaired: "Nicht verknüpft",
    telemetryBattery: "Akku",
    telemetryWifi: "WLAN-Signal",
    telemetryAudio: "Lautstärke",
    telemetryStorage: "Speicher belegt",
    telemetryMemory: "RAM belegt",
    telemetryUnavailable: "-",
    telemetryDataAge: "Daten von {{age}}",
  },
  kioskPresence: {
    modalTitle: "Gäste – {{kioskName}}",
    tabletFallback: "Tablet",
    toastAdded: "Gast registriert",
    toastUpdated: "Gast aktualisiert",
    toastDeleted: "Gast entfernt",
    errorGuestNameRequired: "Vorname des Gastes ist erforderlich",
    errorNationalityRequired: "Nationalität ist erforderlich",
    errorDatesRequired: "An- und Abreisedatum sind erforderlich",
    errorDepartureDateRequired: "Abreisedatum ist erforderlich",
    errorDepartureAfterArrival: "Abreise muss nach der Anreise liegen",
    deleteConfirm: "Gast „{{guestName}}“ entfernen?",
    replaceCurrentTitle: "Aktuellen Gästeaufenthalt beenden?",
    replaceCurrentMessage:
      "{{guestName}} ist derzeit auf diesem Tablet eingecheckt. Um einen neuen Gast zu registrieren, beenden wir den aktuellen Aufenthalt jetzt und starten den neuen.",
    replaceCurrentConfirm: "Aufenthalt beenden und neuen Gast registrieren",
    sectionCurrentGuest: "Aktueller Gast",
    sectionUpcoming: "Neuer Gast",
    emptyNoCurrentGuest: "Kein aktueller Gast",
    emptyNoUpcoming: "Keine Gäste registriert",
    ctaAddPresence: "Gast hinzufügen",
    labelGuestName: "Vorname des Gastes",
    labelGuestLastName: "Nachname",
    labelGuestEmail: "E-Mail",
    labelGuestPhone: "Telefon",
    labelNationality: "Nationalität",
    labelArrivalDate: "Anreisedatum",
    labelArrivalTime: "Anreisezeit",
    labelDepartureDate: "Abreisedatum",
    labelDepartureTime: "Abreisezeit",
    scheduleLaterArrival: "Gast kommt an einem späteren Datum",
    scheduleLaterArrivalHint:
      "Unmarkiert lassen, um ab jetzt einzuchecken. Aktivieren, um einen zukünftigen Aufenthalt auf diesem Tablet einzureihen.",
    labelPeople: "Personen",
    labelChildrenCheckbox: "Kinder",
    labelNotes: "Notizen",
    childrenBadge: "Kinder",
    placeholderGuestName: "z. B. Mario",
    placeholderGuestLastName: "z. B. Rossi",
    placeholderGuestEmail: "z. B. mario.rossi@email.com",
    placeholderGuestPhone: "z. B. +393331234567",
    placeholderNationality: "z. B. Italien",
    placeholderNotes: "Optionale Notizen…",
    peopleCount_one: "{{count}} Person",
    peopleCount_other: "{{count}} Personen",
    buttonAddPresence: "Gast registrieren",
    buttonUpdatePresence: "Gast aktualisieren",
    consentSectionTitle: "Einwilligungsformular",
    consentSectionHint:
      "E-Mail und Telefon werden nur gespeichert, wenn der Gast mindestens eine Option unten akzeptiert.",
    consentMarketing:
      "ICH WILLIGE ein in die Verarbeitung meiner personenbezogenen Daten durch Guestify Italia S.r.l. für Marketingkommunikation, Newsletter und kommerzielle Angebote.",
    consentProfiling:
      "ICH WILLIGE ein in die Verarbeitung meiner personenbezogenen Daten durch Guestify Italia S.r.l. zur Analyse meiner Präferenzen und zum Erhalt personalisierter Angebote und Dienstleistungen.",
    consentThirdParty:
      "ICH WILLIGE ein in die Übermittlung meiner personenbezogenen Daten durch Guestify Italia S.r.l. an ausgewählte Partner zu Marketingzwecken.",
    consentRecordedBadge: "Einwilligung erfasst",
  },
} as const;
